import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";

export const GenericPage_Article_Fragment = graphqlShopifyStorefront(`
  fragment GenericPage_Article on Page {
    classes: metafield(namespace: "custom", key: "classes") {
      __typename
      value
    }
    style: metafield(namespace: "custom", key: "style") {
      __typename
      value
    }
    styleSm: metafield(namespace: "custom", key: "style_sm") {
      __typename
      value
    }
    styleMd: metafield(namespace: "custom", key: "style_md") {
      __typename
      value
    }
    styleLg: metafield(namespace: "custom", key: "style_lg") {
      __typename
      value
    }
    styleXl: metafield(namespace: "custom", key: "style_xl") {
      __typename
      value
    }
  }
`);
